import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/scss/reset.scss";
import "./styles/scss/common.scss";
import "@fortawesome/fontawesome-pro/css/all.min.css";
import "@fortawesome/fontawesome-pro/css/fontawesome.min.css";
import "@fortawesome/fontawesome-pro/css/thin.min.css";
import "@fortawesome/fontawesome-pro/css/sharp-thin.min.css";
// import "./styles/management.css";
// import "./styles/website.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";
import { installApiFetch } from "./utils/apiFetch";

// 全画面の API 呼び出しにセッション送信と 401→ログイン画面 を一括適用（描画前に設置）
installApiFetch();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
